import { Component } from '@angular/core';

@Component({
    selector: 'exp-error-page',
    template: '<h1>Routes can not be fetched</h1>',
})
export class ExpErrorPageComponent {}
